import axios from "axios";
// import { toastr } from "react-redux-toastr";
const instance = axios.create();
instance.interceptors.response.use(
	function (res) {
		return res.data;
	},
	function (error) {
		let message = "Something went wrong";
		let status = "failure";
		if (error.response && error.response.status === 401) {
			// toastr.error("Error", "Session Timed Out. Please Login Again.");
			// import store and logout action and then call logout actions
			const err = {};
			throw err;
		}
		try {
			message = error.response.data.message || message;
			status = error.response.data.status || status;
		} catch (e) {}
		const err2 = { message, status };
		throw err2;
	}
);
export default instance;
